import Vue from "vue";
import ToolBar from "@/components/ToolBar.vue";
import Pagination from "@/components/Pagination.vue";
// 分页组件
import vPage from "./components/v-page";

Vue.component("ToolBar", ToolBar);
Vue.component("Pagination", Pagination);

Vue.component(vPage.name, vPage);
